<template>
  <div id="job" class="job container">
        <router-link to="/">
            <button class="acc-button-2 mb-5">Back to Results</button>
        </router-link>
        <div v-if="job">
            <div v-if="applying" class="row">
                <div class="col-12">
                    <h2 class="job-applying">Apply for<br></h2>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-12 overflow-hidden">
                    <h1 class="job-title">{{this.job.title}}</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="job-meta d-flex flex-wrap">
                        <div class="pe-1 d-flex flex-row flex-wrap" v-if="job.offices.length > 0" >
                            <strong><span>Location<span v-if="job.offices.length > 1">s</span>:&nbsp;</span></strong>
                            <div v-for="(office, index) in job.offices" v-bind:key="office.id">
                                {{office.name}}
                                <span v-if="index < job.offices.length - 1">&nbsp;/&nbsp;</span>
                            </div>
                        </div>
                        <div class="pe-1" v-if="job.departments.length > 0">
                            <strong><span>Department:</span></strong> {{this.job.departments[0].name}}
                        </div>
                        <div class="pe-1">
                            <strong><span>Type:</span></strong> Fulltime
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="!applying" class="row mt-5">
                <div class="col-12">
                    <div v-html="decodedContent" class="job-description _dc"></div>
                </div>
                <!--<div class="col-12">
                    <h4 class="ac_desc_title _dc">Why work for Astound Digital?</h4>
                    <p class="ac_desc_desc">Whether you’re working directly with our world-renowned clients or with your Astound colleagues from around the globe, you will shape the future of digital commerce, using emerging technologies and innovative approaches.</p>
                    <p class="job-align-center ac_desc_title"><strong>Grow your career with Astound Digital, and discover exciting opportunities while doing the work you love!</strong></p>
                    <br>
                </div>-->
            </div>
            <div v-show="applying" class="row mt-5">
                <div class="col-12">
                    <div ref="grnhse_iframe" id="grnhse_app"></div>
                </div>
            </div>
        
            <button class="acc-button-3" @click="toggleApplying()">{{buttonText}}</button>

            <!-- <router-link class="btn btn-primary" :to="{ name: 'Apply', params: { id: job.id } }">
                Apply Now
            </router-link>    -->
        </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
    name: 'Job',
    components: {
    },
    data() {
        return {
            job: null,
            applying: false,
            buttonText: "Apply Now"
        }
    },
    mounted() {
        this.getData();
        document.getElementById('section-3-7').style.display = 'none';
        document.body.classList.add('acc-job');
    },
    methods: {
        scrollToTop() {
            window.scrollTo(0,0);
        },
        getData() {
            let url = "https://boards-api.greenhouse.io/v1/boards/" + process.env.VUE_APP_GH_BOARD + "/jobs";
            let requestUrl = url + '/' + this.$route.params.id;
            axios
                .get(requestUrl)
                .then(response => {
                this.job = response.data;
                });
        },
        htmlDecode(input) {
            var doc = new DOMParser().parseFromString(input, "text/html");
            return doc.documentElement.textContent;
        },
        toggleApplying() {
            this.applying = !this.applying;
            if (this.applying) {
                this.buttonText = "Back";
                // eslint-disable-next-line no-undef
                if ( this.$refs.grnhse_iframe.innerHTML.length == 0 ) Grnhse.Iframe.load(this.job.id);
                this.scrollToTop();
            } else {
                this.buttonText = "Apply Now";
            }
        }
    },
    computed: {
        decodedContent: function () {
            return this.htmlDecode(this.job.content);
        }
    }  
}

</script>